import { Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';

type PixAutomaticInfoLabelProps = {
  title: string;
  content: string | ReactNode;
};

export const PixAutomaticInfoLabel = ({
  content,
  title,
}: PixAutomaticInfoLabelProps): ReactNode => {
  return (
    <Stack sx={{ alignItems: 'center' }}>
      <Typography variant='h6' fontWeight='bold' textAlign='center'>
        {title}
      </Typography>
      <Typography variant='body1'>{content}</Typography>
    </Stack>
  );
};
